var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNapeOfNeck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "7px",
    viewBox: "0 0 47 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nape of Neck") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-11",
    transform: "translate(-65.000000, -87.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.6361675,87 L100.025908,87 C101.998983,88.8641111 103.70202,90.2150297 105.135021,91.0527556 C106.568022,91.8904815 108.856349,92.8728963 112,94 L65.0555505,94 C67.6098243,93.0448427 69.6782085,92.1610846 71.2607032,91.3487256 C72.8431978,90.5363667 74.6350193,89.0867915 76.6361675,87 Z",
    id: "Nape-of-Neck"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNapeOfNeck);
export default __webpack_public_path__ + "static/media/NapeOfNeck.080658747d883496186122a098ffab71.svg";
export { ForwardRef as ReactComponent };